import { useState, useRef, useEffect } from 'react';
import { FiChevronDown, FiGrid } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import styles from './DerasarSelector.module.css';

const DerasarSelector = () => {
  const { user, approvedDerasars, activeDerasarId, setActiveDerasarId } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  if (user?.role === 'derasar_admin') return null;
  if (!approvedDerasars || approvedDerasars.length === 0) return null;

  const active = approvedDerasars.find((d) => {
    const id = d.derasarId?.id || d.derasarId;
    return id?.toString() === activeDerasarId;
  });

  const activeName = active?.derasarId?.name || 'Select Derasar';

  return (
    <div className={styles.wrapper} ref={ref}>
      <button className={styles.trigger} onClick={() => setOpen((o) => !o)}>
        <FiGrid size={14} />
        <span className={styles.triggerName}>{activeName}</span>
        <FiChevronDown className={`${styles.chevron} ${open ? styles.open : ''}`} />
      </button>

      {open && (
        <div className={styles.dropdown}>
          <div className={styles.dropdownHeader}>My Derasars</div>
          {approvedDerasars.length === 0 ? (
            <div className={styles.emptyMsg}>No derasars joined</div>
          ) : (
            approvedDerasars.map((d) => {
              const id = (d.derasarId?.id || d.derasarId)?.toString();
              const isActive = id === activeDerasarId;
              return (
                <div
                  key={id}
                  className={`${styles.option} ${isActive ? styles.active : ''}`}
                  onClick={() => { setActiveDerasarId(id); setOpen(false); }}
                >
                  <div className={styles.optionDot} />
                  <span className={styles.optionName}>{d.derasarId?.name || id}</span>
                  <span className={styles.optionRole}>{d.role}</span>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default DerasarSelector;
